var PlayerTrackEvent = /* @__PURE__ */ ((PlayerTrackEvent2) => {
  PlayerTrackEvent2["SET_URL_PLAYBACK"] = "setUrlPlayback";
  PlayerTrackEvent2["SET_AVAILABLE_AUDIO_LANGUAGES"] = "setAvailableAudioLanguages";
  PlayerTrackEvent2["SET_AVAILABLE_SUBTITLE_TRACKS"] = "setAvailableSubtitleTracks";
  PlayerTrackEvent2["SET_CURRENT_BITRATE"] = "setCurrentBitRate";
  PlayerTrackEvent2["SET_AVAILABLE_VIDEO_BITRATES"] = "setAvailableVideoBitRates";
  return PlayerTrackEvent2;
})(PlayerTrackEvent || {});
const PLAYER_TRACKS_EVENTS = PlayerTrackEvent;
const AUDIO_LANGUAGE_NOT_AVAILABLE = "undetermined";
var KeySystem = /* @__PURE__ */ ((KeySystem2) => {
  KeySystem2["WIDEVINE"] = "widevine";
  KeySystem2["PLAYREADY"] = "playready";
  KeySystem2["FAIRPLAY"] = "fairplay";
  return KeySystem2;
})(KeySystem || {});
const KEY_SYSTEM_NAMES = {
  ["widevine" /* WIDEVINE */]: "com.widevine.alpha",
  ["playready" /* PLAYREADY */]: "com.microsoft.playready",
  ["fairplay" /* FAIRPLAY */]: "com.apple.fps"
};
const DEFAULT_SEEK_THRESHOLD_MULTIPLIER = 2;
const DEFAULT_CATCHUP_PLAYBACK_RATE = 1.05;
const DEFAULT_FALLBACK_PLAYBACK_RATE = 0.95;
var PlayerRequestType = /* @__PURE__ */ ((PlayerRequestType2) => {
  PlayerRequestType2["MANIFEST"] = "MANIFEST";
  PlayerRequestType2["SEGMENT"] = "SEGMENT";
  PlayerRequestType2["LICENSE"] = "LICENSE";
  PlayerRequestType2["APP"] = "APP";
  PlayerRequestType2["TIMING"] = "TIMING";
  PlayerRequestType2["SERVER_CERTIFICATE"] = "SERVER_CERTIFICATE";
  PlayerRequestType2["KEY"] = "KEY";
  PlayerRequestType2["ADS"] = "ADS";
  PlayerRequestType2["OTHER"] = "OTHER";
  return PlayerRequestType2;
})(PlayerRequestType || {});

export { AUDIO_LANGUAGE_NOT_AVAILABLE, DEFAULT_CATCHUP_PLAYBACK_RATE, DEFAULT_FALLBACK_PLAYBACK_RATE, DEFAULT_SEEK_THRESHOLD_MULTIPLIER, KEY_SYSTEM_NAMES, KeySystem, PLAYER_TRACKS_EVENTS, PlayerRequestType, PlayerTrackEvent };
//# sourceMappingURL=constants.js.map
